import cache_mixin from "~/mixins/cache"

export default {
  mixins: [cache_mixin],
  methods: {
    backupSessionId: function (secret, id) {
      const key = "backupSession_" + id
      const value = secret

      window.localStorage.setItem(key, value)
    },
    swapUser: function (secret, id, cb) {
      this.$axios
        .$post("/auth/switch/" + id + "/swap/", {
          secret,
        })
        .then((resp) => {
          if (typeof cb === "function") cb(null, resp)
        })
        .catch((err) => {
          if (typeof cb === "function") cb(err, null)
        })
    },
    addAccount: function (isfacebook) {
      var data

      if (isfacebook === true) {
        if (this.fbIsLoggedIn)
          data = { access_token: this.fbData.authResponse.accessToken }
        else return this.errHandle(2)
      } else data = { email: this.email, password: this.password }
      this.$axios
        .$post("/auth/switch/", data)
        .then((resp) => {
          if (resp) {
            this.backupSessionId(resp.target_secret, resp.target_id)
            this.backupSessionId(resp.origin_secret, this.$store.state.user.id)
            this.swapUser(resp.target_secret, resp.target_id, (err) => {
              if (!err) {
                this.cleanCacheAll()
                this.$store.dispatch("draft/RESET")
                this.$store.dispatch("login/SET_DISPLAY", false)
                window.location.href = window.location.origin + "/"
              } else this.errHandle()
            })
          } else this.errHandle(1)
        })
        .catch(() => {
          this.errHandle(1)
        })
    },
  },
}
